import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _buyNowPayLaterMethod = { paymentOptions: '_buyNowPayLaterOption' };
var _buyNowPayLaterOption = {
    installmentAmount: 'DOUBLE',
    totalAmount: 'DOUBLE',
    interestAmount: 'DOUBLE',
};
var _getBuyNowPayLaterMethodRequest = {};
var _getBuyNowPayLaterMethodResponse = {
    paymentMethod: '_buyNowPayLaterMethod',
};
var _getPaymentMethodRequest = {};
var _getPaymentMethodResponse = { paymentMethod: '_paymentMethod' };
var _getSavedPaymentMethodDetailsByAgreementIdRequest = {};
var _getSavedPaymentMethodDetailsByAgreementIdResponse = {};
var _googlePayStartPaymentRequest = {};
var _googlePayStartPaymentResponse = {};
var _installments = { minTransactionAmount: 'DOUBLE' };
var _listBuyNowPayLaterMethodsRequest = {};
var _listBuyNowPayLaterMethodsResponse = {
    paymentMethods: '_buyNowPayLaterMethod',
};
var _listExpressPaymentMethodsRequest = {};
var _listExpressPaymentMethodsResponse = {};
var _listPaymentMethodsRequest = {};
var _listPaymentMethodsResponse = { paymentMethods: '_paymentMethod' };
var _paymentMethod = { installments: '_installments' };
var _validateMerchantRequest = {};
var _validateMerchantResponse = {};
function resolveWixPaymentApiPayV2PaymentMethodServiceUrl(opts) {
    var domainToMappings = {
        'cashier-services._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'difm._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'invoices._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'progallery._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'progallerycdn._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'scheduler._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'events._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '',
                destPath: '',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'vod.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixhotels.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'test-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/payments',
                destPath: '/api/merchant',
            },
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
            {
                srcPath: '/api/plugin/v1/transactions',
                destPath: '/api/plugin/v1/transactions',
            },
            {
                srcPath: '/payments/api/merchant',
                destPath: '/api/merchant',
            },
        ],
        'us-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'eu-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'payments-sb.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/ambassador/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        _: [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'tpa.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'pricing-plans.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/lib-mbapi/include/modules/gateway/return/paypal.php',
                destPath: '/api/payPal/payments/legacy-ipn-to-ignore',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'payment-webhooks.wixapps.net': [
            {
                srcPath: '/cashier/accounts/stripe',
                destPath: '/api/merchant/stripe',
            },
            {
                srcPath: '/cashier/transactions/stripe',
                destPath: '/api/stripe',
            },
        ],
        'cashier-services.wixapis.com': [
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'currency-converter.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'challenger.wixapps.net': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixPaymentApiPayV2GooglePayPaymentMethodServiceUrl(opts) {
    var domainToMappings = {
        'cashier-services._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'difm._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'invoices._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'progallery._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'progallerycdn._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'scheduler._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'events._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '',
                destPath: '',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'vod.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixhotels.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'test-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/payments',
                destPath: '/api/merchant',
            },
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
            {
                srcPath: '/api/plugin/v1/transactions',
                destPath: '/api/plugin/v1/transactions',
            },
            {
                srcPath: '/payments/api/merchant',
                destPath: '/api/merchant',
            },
        ],
        'us-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'eu-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'payments-sb.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/ambassador/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        _: [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'tpa.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'pricing-plans.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/lib-mbapi/include/modules/gateway/return/paypal.php',
                destPath: '/api/payPal/payments/legacy-ipn-to-ignore',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'payment-webhooks.wixapps.net': [
            {
                srcPath: '/cashier/accounts/stripe',
                destPath: '/api/merchant/stripe',
            },
            {
                srcPath: '/cashier/transactions/stripe',
                destPath: '/api/stripe',
            },
        ],
        'cashier-services.wixapis.com': [
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'currency-converter.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'challenger.wixapps.net': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixPaymentApiPayV2ApplePayPaymentMethodServiceUrl(opts) {
    var domainToMappings = {
        'cashier-services._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'difm._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'invoices._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'progallery._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'progallerycdn._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'scheduler._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'events._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '',
                destPath: '',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'vod.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixhotels.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'test-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/payments',
                destPath: '/api/merchant',
            },
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
            {
                srcPath: '/api/plugin/v1/transactions',
                destPath: '/api/plugin/v1/transactions',
            },
            {
                srcPath: '/payments/api/merchant',
                destPath: '/api/merchant',
            },
        ],
        'us-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'eu-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'payments-sb.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/ambassador/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        _: [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'tpa.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'pricing-plans.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/lib-mbapi/include/modules/gateway/return/paypal.php',
                destPath: '/api/payPal/payments/legacy-ipn-to-ignore',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'payment-webhooks.wixapps.net': [
            {
                srcPath: '/cashier/accounts/stripe',
                destPath: '/api/merchant/stripe',
            },
            {
                srcPath: '/cashier/transactions/stripe',
                destPath: '/api/stripe',
            },
        ],
        'cashier-services.wixapis.com': [
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'currency-converter.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'challenger.wixapps.net': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Validate ApplePay merchant, returns response from Apple */
export function validateMerchant(payload) {
    var _a = serializer(_validateMerchantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateMerchantResponse, {}).fromJSON;
    function __validateMerchant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'POST',
            methodFqn: 'wix.payment.api.pay.v2.ApplePayPaymentMethodService.ValidateMerchant',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2ApplePayPaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}/apple-pay-validate-merchant',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateMerchant.fromReq = fromReq;
    __validateMerchant.__isAmbassador = true;
    return __validateMerchant;
}
export function googlePayStartPayment(payload) {
    var _a = serializer(_googlePayStartPaymentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_googlePayStartPaymentResponse, {}).fromJSON;
    function __googlePayStartPayment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'POST',
            methodFqn: 'wix.payment.api.pay.v2.GooglePayPaymentMethodService.GooglePayStartPayment',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2GooglePayPaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/google-pay-start-payment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __googlePayStartPayment.fromReq = fromReq;
    __googlePayStartPayment.__isAmbassador = true;
    return __googlePayStartPayment;
}
/**
 * Returns all available payment methods for a specified account or order.
 *
 * **Auth rules**
 *
 * Requires person or server identity to be present.
 *
 * Server identity has permissions to view payment methods without any
 * additional rules.
 *
 * Person identity has permissions to view payment methods without any
 * additional rules.
 *
 * You can find more information about authentication and authorization in a
 * separate [guide][1].
 *
 * **Error responses**
 *
 * - 401 - person identity and a server identity are both missing.
 * - 403 - passed identity does not have permission to perform this action.
 *
 * [1]: ../../guides/Authentication%20and%20authorization
 */
export function list(payload) {
    var _a = serializer(_listPaymentMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPaymentMethodsResponse, {
        _installments: _installments,
        _paymentMethod: _paymentMethod,
    }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.PaymentMethodService.List',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}/payment-methods',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                        protoPath: '/api/payments/v2/accounts/{accountId}/payment-methods',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/**
 * Returns a specific payment method for a specified account or order. The
 * payment method includes details on what is supported by this payment
 * method, as well as which payment provider is connected to it, and what
 * mandatory fields it requires.
 *
 * **Auth rules**
 *
 * Requires person or server identity to be present.
 *
 * Server identity has permissions to view the order without any additional
 * rules.
 *
 * Person identity has permissions to view payment methods without any
 * additional rules.
 *
 * You can find more information about authentication and authorization in a
 * separate [guide][1].
 *
 * **Error responses**
 *
 * - 401 - person identity and a server identity are both missing.
 * - 403 - passed identity does not have permission to perform this action.
 *
 * [1]: ../../guides/Authentication%20and%20authorization
 */
export function get(payload) {
    var _a = serializer(_getPaymentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPaymentMethodResponse, {
        _installments: _installments,
        _paymentMethod: _paymentMethod,
    }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.PaymentMethodService.Get',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}/payment-methods/{paymentMethod}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                        protoPath: '/api/payments/v2/accounts/{accountId}/payment-methods/{paymentMethod}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
export function listExpressPaymentMethods(payload) {
    var _a = serializer(_listExpressPaymentMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listExpressPaymentMethodsResponse, {}).fromJSON;
    function __listExpressPaymentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.PaymentMethodService.ListExpressPaymentMethods',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}/express-payment-methods',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listExpressPaymentMethods.fromReq = fromReq;
    __listExpressPaymentMethods.__isAmbassador = true;
    return __listExpressPaymentMethods;
}
/** returns available payment methods with BNPL */
export function listBuyNowPayLaterMethods(payload) {
    var _a = serializer(_listBuyNowPayLaterMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listBuyNowPayLaterMethodsResponse, {
        _buyNowPayLaterMethod: _buyNowPayLaterMethod,
        _buyNowPayLaterOption: _buyNowPayLaterOption,
    }).fromJSON;
    function __listBuyNowPayLaterMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.PaymentMethodService.ListBuyNowPayLaterMethods',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}/bnpl/payment-methods',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listBuyNowPayLaterMethods.fromReq = fromReq;
    __listBuyNowPayLaterMethods.__isAmbassador = true;
    return __listBuyNowPayLaterMethods;
}
/** returns single available payment method with BNPL by id */
export function getBuyNowPayLaterMethod(payload) {
    var _a = serializer(_getBuyNowPayLaterMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBuyNowPayLaterMethodResponse, {
        _buyNowPayLaterMethod: _buyNowPayLaterMethod,
        _buyNowPayLaterOption: _buyNowPayLaterOption,
    }).fromJSON;
    function __getBuyNowPayLaterMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.PaymentMethodService.GetBuyNowPayLaterMethod',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}/bnpl/payment-methods/{paymentMethod}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBuyNowPayLaterMethod.fromReq = fromReq;
    __getBuyNowPayLaterMethod.__isAmbassador = true;
    return __getBuyNowPayLaterMethod;
}
/** Get SavedPaymentMethodDetails by agreementId */
export function getSavedPaymentMethodDetailsByAgreementId(payload) {
    var _a = serializer(_getSavedPaymentMethodDetailsByAgreementIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSavedPaymentMethodDetailsByAgreementIdResponse, {}).fromJSON;
    function __getSavedPaymentMethodDetailsByAgreementId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.payment_method',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.PaymentMethodService.GetSavedPaymentMethodDetailsByAgreementId',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixPaymentApiPayV2PaymentMethodServiceUrl({
                protoPath: '/api/payments/v2/payment-agreements/{paymentAgreementId}/payment-method',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSavedPaymentMethodDetailsByAgreementId.fromReq = fromReq;
    __getSavedPaymentMethodDetailsByAgreementId.__isAmbassador = true;
    return __getSavedPaymentMethodDetailsByAgreementId;
}
//# sourceMappingURL=http.impl.js.map